/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: EwKexkGqvtH7
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicPageLayout.module.css"; // plasmic-import: EwKexkGqvtH7/css

createPlasmicElementProxy;

export const PlasmicPageLayout__VariantProps = new Array("layoutSections");

export const PlasmicPageLayout__ArgProps = new Array("content");

const $$ = {};

function PlasmicPageLayout__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layoutSections",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layoutSections
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"pageLayout"}
      data-plasmic-override={overrides.pageLayout}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.pageLayout,
        {
          [sty.pageLayoutlayoutSections_withNav]: hasVariant(
            $state,
            "layoutSections",
            "withNav"
          ),
          [sty.pageLayoutlayoutSections_withoutNav]: hasVariant(
            $state,
            "layoutSections",
            "withoutNav"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"sidenavSpacer"}
        data-plasmic-override={overrides.sidenavSpacer}
        className={classNames(projectcss.all, sty.sidenavSpacer)}
      />

      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <div
          data-plasmic-name={"slotPageContent"}
          data-plasmic-override={overrides.slotPageContent}
          className={classNames(projectcss.all, sty.slotPageContent, {
            [sty.slotPageContentlayoutSections_withoutNav]: hasVariant(
              $state,
              "layoutSections",
              "withoutNav"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.content
          })}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  pageLayout: ["pageLayout", "sidenavSpacer", "freeBox", "slotPageContent"],
  sidenavSpacer: ["sidenavSpacer"],
  freeBox: ["freeBox", "slotPageContent"],
  slotPageContent: ["slotPageContent"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPageLayout__ArgProps,
          internalVariantPropNames: PlasmicPageLayout__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPageLayout__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageLayout") {
    func.displayName = "PlasmicPageLayout";
  } else {
    func.displayName = `PlasmicPageLayout.${nodeName}`;
  }
  return func;
}

export const PlasmicPageLayout = Object.assign(
  // Top-level PlasmicPageLayout renders the root element
  makeNodeComponent("pageLayout"),
  {
    // Helper components rendering sub-elements
    sidenavSpacer: makeNodeComponent("sidenavSpacer"),
    freeBox: makeNodeComponent("freeBox"),
    slotPageContent: makeNodeComponent("slotPageContent"),
    // Metadata about props expected for PlasmicPageLayout
    internalVariantProps: PlasmicPageLayout__VariantProps,
    internalArgProps: PlasmicPageLayout__ArgProps
  }
);

export default PlasmicPageLayout;
/* prettier-ignore-end */
